import { fromJS } from 'immutable';

export default {
  FETCH_STATUS_PAGE_SUMMARY_SUCCESS: (state, action) => {
    return state.setIn(['statuspage', 'summary'], fromJS(action.summary));
  }
};
